import { Link } from "react-router-dom";

/** An unknown path, or a node or scenario that doesn't exist (or was deleted). */
export function NotFoundPage({ what = "page" }: { what?: string }) {
	return (
		<div className="mx-auto max-w-lg space-y-3 py-16 text-center">
			<h1 className="text-2xl font-semibold">There is no such {what}</h1>
			<p className="text-sm text-muted-foreground">It may have been deleted, or the link is wrong. Search with ⌘K, or go back to the worldview.</p>
			<Link to="/" className="inline-block text-sm font-medium underline underline-offset-4">
				Go to the worldview
			</Link>
		</div>
	);
}
